import React from 'react'

const ConceptSize = props => {
  return (
    <svg
      width='27'
      height='12'
      fill='none'
      viewBox='0 0 27 12'
      {...props}
    >
      <path d='M10.667 0L24 4v4l-13.333 4V0z' opacity='0.3' />
      <path

        d='M3.5 0h7L14 6l-3.5 6h-7L0 6l3.5-6zM25.5 4h-2.333L22 6l1.167 2H25.5l1.167-2L25.5 4z'
      />
    </svg>
  )
}

export default ConceptSize
